import IDimensions from '../../../model/IDimensions';
import dataLayerToggleVerification from '../../../../../../common/utilities/dataLayerToggleVerification';
import digitalDataAssignment from '../../../../../../common/utilities/digitalDataAssignment';
import {
  DataLayerEvent,
  DataLayerFormName,
  DataLayerFormStage,
  FormFieldName,
} from '../../../../../../common/utilities/customDatalayerInterface';
import { IExteriorColour } from '../../../../../../common/model/IColours';

const ColorAttributeDataLayerRest = (value: string, choices: IExteriorColour[], dimension: IDimensions) => {
  try {
    const isDataLayer = dataLayerToggleVerification(dimension);
    if (isDataLayer) {
      const selectedColorTitle = choices?.find((color: IExteriorColour) => value === color.id)?.title;
      digitalDataAssignment({
        event: DataLayerEvent.FORM_INTERACT,
        form: {
          name: DataLayerFormName.CONFIGURATOR,
          stage: DataLayerFormStage.CONFIGURE_CAR,
          field: {
            name: FormFieldName.COLOR,
            value: selectedColorTitle,
          },
        },
      });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('DataLayer error', err);
  }
};
export default ColorAttributeDataLayerRest;
